import { render, staticRenderFns } from "./infoBoxPrice.vue?vue&type=template&id=5f34387e&scoped=true&"
import script from "./infoBoxPrice.vue?vue&type=script&lang=js&"
export * from "./infoBoxPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f34387e",
  null
  
)

export default component.exports